// extracted by mini-css-extract-plugin
export default {"radio":"Radio-module__radio__0DSCs"};